import axiosInstance from "./AxiosInstance";

// List forms
export function listForms(payload) {
  return axiosInstance.post("/admin/formList", payload);
}

// Add a new form
export function addForm(payload) {
  return axiosInstance.post("/admin/addForm", payload);
}

// Edit an existing form
export function editForm(payload) {
  return axiosInstance.post("/admin/editForm", payload);
}

// Delete a form
export function deleteForm(payload) {
  return axiosInstance.post("/admin/deleteForm", payload);
}
